import { forwardRef } from "react";
import { Nav } from "react-bootstrap";

export const NavDatePicker = forwardRef<
  HTMLAnchorElement,
  { title?: string; onClick?: () => void; className?: string }
>(({ title, onClick, className }, ref) => (
  <Nav.Link
    ref={ref}
    onClick={onClick}
    className={className + " dropdown-toggle"}
  >
    {title}
  </Nav.Link>
));
